

/**
 * @name ArtistHours
 * @description Function for the ArtistHours service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @return {object} Returns the ArtistHours service
 */
function ArtistHours(
  $http,
  ENDPOINT,
  AlertMessages,
  Session
) {
  ArtistHours.get = get;

  /**
   * @name get
   * @description Function to get an array of artist hours
   * @param {number} id The collector ID of the artist
   * @return {array} Returns an array of hours
   */
  function get(id) {
    return $http.get(ENDPOINT.server +
    'schedules/api/v1.1/artist-hours/?artist_id=' + id)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return ArtistHours;
}

angular
  .module('inkfinder')
  .factory('ArtistHours', ArtistHours);



// WEBPACK FOOTER //
// ./components/artists/artist/hours/artist-hours.service.js